import loadable from "@loadable/component";
import React from "react";
import "./CoastHeaderUser.style.scss";

const CoastUserProfile = loadable(() => import("./CoastUserProfile.component"), {
    ssr: false,
});

export const CoastHeaderUser = () => (
    <div className="header-user">
        <CoastUserProfile />
    </div>
);
